import { useGetOrganizationSummary } from "@src/api/organization-summaries/get-organization-summary";

export const useIsAgencyAdmin = () => {
  const orgSummary = useGetOrganizationSummary();

  return orgSummary.data?.org?.isAgencyUser ?? false;
};
